import {Component, OnInit} from '@angular/core';
import {FadeZoomInTop} from "../../animations/fade-zoom-in-top.decorator";
import {Router, NavigationStart, RoutesRecognized} from "@angular/router";
import {NeoGlobalService, Utils} from 'ng-neo';
import {NgProgress} from "@ngx-progressbar/core";
import {ToastrService} from "ngx-toastr";
import {NeoStorageService} from "ng-neo/index";

@FadeZoomInTop()
@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styles: []
})
export class MainLayoutComponent implements OnInit {

    // Alerts
    private alerts = [];

    constructor(private _router: Router,
                private _ngProgrees: NgProgress,
                private toastr: ToastrService,
                private _storage: NeoStorageService,
                private _gs: NeoGlobalService) {
    }

    ngOnInit() {
        this._router.events.subscribe((event) => {
            // Si el evento es de final de navegacion
            // Seteamos el porcentaje
            if (event instanceof NavigationStart) {
                this._gs.set('loading', 'start');
            } else {
                this._gs.set('loading', 'done');
            }

            if (event instanceof RoutesRecognized) {

                let data = this.getData(event);
                this._gs.set("history", {title: data.pageTitle, href: event.url});
            }
        });

        this._gs.subscribe('alerts', ({current}) => {
            if (Array.isArray(current)) {
                this.alerts = current;
            } else if (typeof current === 'object') {
                if (!Array.isArray(this.alerts)) {
                    this.alerts = [current];
                } else {
                    this.alerts.push(current);
                }

                this.toastr.error(current.msg, "Error!");
            }
        });
    }

    private getData(event: RoutesRecognized) {

        let data = event.state.root.data || {};
        let dataCloned: any = Utils.clone(data);

        for (let i = 0, m; m = event.state.root.children[i]; ++i) {
            if (m.data) {
                dataCloned =  Utils.clone(m.data) || {};
                break;
            }
        }

        dataCloned.pageTitle = dataCloned.pageTitle || '';
        return data;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/app-layouts/main-layout.component.ts